import { Appearance } from '../submodules/angular-ui-common/appearance';
import { Color } from './color';

export const appearance: Appearance = {
    publicArea: {
        header: {
            height: 60,
            bgColor: Color.light,
            fontColor: Color.main,
            logo: {
                front: {
                    show: true,
                    regular: {
                        src: './assets/images/header-logo-small.svg',
                        height: 56,
                        width: 118
                    },
                    compact: {
                        src: './assets/images/header-logo-small.svg',
                        height: 56,
                        width: 118
                    }
                },
                back: {
                    show: false
                }
            },
            menu: {
                show: false
            },
            profileSection: {
                show: true,
                hideIfNotAuthenticated: true
            },
            languageChooser: {
                show: false
            },
            contactUs: {
                show: false
            }
        },
        login: {
            bgColor: Color.light,
        }
    },
    privateArea: {
        header: {
            height: 60,
            bgColor: Color.light,
            fontColor: Color.main,
            logo: {
                front: {
                    show: true,
                    regular: {
                        src: './assets/images/header-logo-small.svg',
                        height: 56,
                        width: 118
                    },
                    compact: {
                        src: './assets/images/header-logo-small.svg',
                        height: 56,
                        width: 118
                    }
                },
                back: {
                    show: false
                }
            },
            languageChooser: {
                show: false
            },
            contactUs: {
                show: false
            },
            profileSection: {
                show: true
            },
            moreMenu: {
                show: true,
                languageChooser: {
                    show: false
                },
                about: {
                    show: true
                }
            }
        },
        menu: {
            show: true,
            mode: 'bordered',
            spacing: '2px',
            fontSize: '1.1rem',
            fontColor: Color.main,
            selectedItemFontColor: Color.light,
            hoverItemFontColor: Color.light,
            bgColor: 'transparent',
            selectedItemBgColor: Color.auxiliary,
            hoverItemBgColor: Color.tertiary,
            borderColor: 'transparent',
            selectedItemBorderColor: 'transparent',
            hoverItemBorderColor: 'transparent',
            underlineColor: 'yellow',
            selectedItemUnderlineColor: 'green',
            hoverItemUnderlineColor: 'pink'
        }
    },
    cookiePolicyFooter: {
        bgColor: Color.main
    },
    breadcrumbs: {
        fontColor: Color.light,
        hoverFontColor: Color.light,
        bgColor: Color.auxiliary,
        hoverBgColor: Color.main,
        borderColor: Color.light
    },
    cards:{
        bgColor: 'transparent',
        border: 'none',
        borderRadius: '2px',
        shadow: true
    },
    dialogs:{
        bgColor: Color.auxiliary,
        fontColor: Color.light
    },
    chat: {
        userMessageBgColor: Color.main,
        interlocutorsMessageBgColor: Color.auxiliary
    }
}
